import layout from '../layout'
export default function makeVideoCategoriesRoutes({
  contentType,
  components: { VideoCategoriesListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: VideoCategoriesListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
